import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '../http.service';
import { HelperService } from '../helper.service';
import { HttpClient } from '@angular/common/http';
import { HttpFileService } from '../http-file.service';
import * as XLSX from 'xlsx';
import { Observable, Subject } from 'rxjs';
import { ValidationMessagesService } from '../index.service';

@Injectable({
  providedIn: 'root'
})
export class VisitService {
  constructor(
    private httpService: HttpService,
    public helperService: HelperService,
    public httpClient: HttpClient,
    public httpFileService: HttpFileService,
    private router: Router,
    public validationService: ValidationMessagesService,

  ) { }

  visit_list(payload: any) {
    return this.httpService.post('admin/wylo/visits', payload);
  }

  visitById(id: any) {
    return this.httpService.post(`admin/wylo/get_single_visit`, { visit_id: id });
  }

  visitStages() {
    return this.httpService.post(`admin/wylo/get_visit_status`, { observe: 'response' });
  }

  treatmentPlan(id: any) {
    return this.httpService.post(`admin/wylo/get_treatment_plan`, { health_condition_id: id });
  }

  updateTreatmentPlan(payload: any) {
    return this.httpService.post(`admin/wylo/update_visit_treatment_plan`, payload);
  }

  visit_staus_update(obj: any): Observable<any> {
    return this.httpService.post(`admin/wylo/update_visit_status`, obj);
  }

  visitOrder_list(obj: any): Observable<any> {
    return this.httpService.post(`admin/wylo/get_visit_orders`, obj);
  }

  verify_user_krollid_and_save(obj: any): Observable<any> {
    return this.httpService.post(`admin/wylo/user/verify-user-krollid-and-save`, obj);
  }

  verify_krollid_rx_befor_create(obj: any): Observable<any> {
    return this.httpService.post(`admin/wylo/order/verify-krollid-rx-befor-create`, obj);
  }
  
  get_treatment_denied_reasons(payload: any) {
    return this.httpService.post(`admin/wylo/treatment_denied_reasons`, payload);
  }

  download_PDF(payload: any) {
    return this.httpService.post(`admin/wylo/assessment_pdf_azure`,payload);
  }

  middleWare(obj: any) {
    let payload: any = {}
    if (obj) {
      for (let x in obj) {
        payload[`${x}`] = this.validationService.regexForSecurity(obj[x]);
      }
    }
    return payload
  }

  update_nymble_status(payload: any) {
    return this.httpService.post(`admin/wylo/update_nymble_status`, payload);
  }

  authPaymentCapture(payload: any) {
    return this.httpService.post(`admin/wylo/auth-payment-capture`, payload);
  }
  authPaymentReCapture(payload: any) {
    return this.httpService.post(`admin/wylo/re-capture-auth-payment`, payload);
  }
}
